import { useQuery, useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { ExploreResult } from "@src/types/ExploreResult";

export const useGetSavedSearch = (type: string = "Mix", userId?: any) =>
  useQuery({
    queryKey: ["SAVED_SEARCH", userId],
    queryFn: () =>
      apiClient.get<ExploreResult>(Routes.SAVED_SEARCH_RESULT, {
        params: {
          "saved_search[type]": type,
        },
      }),
  });

export const useDeleteSavedSearch = () => {
  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      apiClient.delete<ExploreResult>(Routes.SAVED_SEARCH_DELETE(id)),
  });
};

export const useUpdateTitleSavedSearch = () => {
  return useMutation({
    mutationFn: ({ data, id }: { data: object; id: number }) =>
      apiClient.put<ExploreResult>(Routes.SAVED_SEARCH_EDIT_TITLE(id), data),
  });
};
